import { render, staticRenderFns } from "./next-queries-list.view.vue?vue&type=template&id=5c651b1c&scoped=true"
import script from "./next-queries-list.view.vue?vue&type=script&lang=ts"
export * from "./next-queries-list.view.vue?vue&type=script&lang=ts"
import style0 from "./next-queries-list.view.vue?vue&type=style&index=0&id=5c651b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c651b1c",
  null
  
)

export default component.exports